import RotatingLoader from './RotatingLoader';

export default RotatingLoader;
